import api from '../api';

interface Orders {
  order: object;
  sync: object;
}

export const getOrders = async (id: string): Promise<Orders> => {
  const response = await api.post(
    `/engine/order/get`,
    { orderId: id },
    {
      timeout: 60000,
    },
  );
  return {
    order: response.data.order,
    sync: response.data.sync,
  };
};
